import { ENV } from "../utils";

export class AccidentType {
  baseApi = ENV.BASE_API;

  async getAccidentTypes(accessToken, active = true) {
    const url = `${this.baseApi}/accident-types?active=${active}`;
    const response = await fetch(url, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async createAccidentType(accessToken, data) {
    const response = await fetch(`${this.baseApi}/add-accident-type`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async updateAccidentType(accessToken, id, data) {
    const response = await fetch(`${this.baseApi}/update-accident-type/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async deleteAccidentType(accessToken, id) {
    const response = await fetch(`${this.baseApi}/delete-accident-type/${id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }
}
